import { $preferencePages } from "@/services/";
import router from '@/router.js'
export default {
  namespaced: true,
  state: {
    validatingName: false,
    preferencePage: {
      name: "",
      html_part: null,
      page_type: "",
      thank_you_page_id: null,
      json_part: null,
      editor_type: null
    }
  },
  mutations: {
    validatingName: (state, value) => {
      state.validatingName = value;
    },
    setPreferencePage: (state, obj) => {
      state.preferencePage = obj;
    }
  },
  actions: {
    setPreferencePageData: ({ commit }, data) => {
      return new Promise((resolve, reject) => {
        try {
          let payload = {
            page_type: data.page_type,
            editor_type: data.editor_type
          };
          $preferencePages.getHtmlJsonPart({ params: payload }).then(res => {
            let name = "Preference_pages_dnd_editor_create";
            if (res.data.data.json_part) {
                data.json_part = res.data.data.json_part;
                name = "Preference_pages_dnd_editor_create";
              } else  if (res.data.data.html_part) {
                data.html_part = res.data.data.html_part;
                name = "Preference_pages_editor_page";
            }
            commit("setPreferencePage", data);
            resolve(data);
          });
        } catch (error) {
          reject(error);
        }
      });
    },
    clearPreferencePageData:({commit})=>{
      let data = {
        name: "",
        html_part: null,
        page_type: "",
        thank_you_page_id: null,
        json_part: null,
        editor_type: null
      }
      commit("setPreferencePage", data);
    }
  },
  getters: {
    validatingName: state => state.validatingName,
    getPreferencePageData: state => state.preferencePage
  }
};